import classNames from "classnames";
import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";
import { useState } from "react";

import IconSort from "@/icons/icon-sort";
import CommonUtils from "~/utils/common-utils";

import Icon from "../common/icon";
import styles from "./category-filters.module.scss";

type Props = {
  pageType: "inSearch" | "inSearchEva" | "inPLPEva" | "inPLPAlgolia";
};

const CategorySortDialog = dynamic(() => import("./category-sort-dialog"), { ssr: false });
const SearchFilterDialog = dynamic(() => import("./search-filter-dialog"), { ssr: false });
const SearchSortDialog = dynamic(() => import("./search-sort-dialog"), { ssr: false });

export default function CategoryFilters(props: Props) {
  const t = useTranslations();
  const [isSorting, setSorting] = useState(false);

  const isAlgoliaSearchPage =
    !CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_ALGOLIA) && props.pageType === "inSearch";
  const isEvaSearchPage =
    CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_ALGOLIA) && props.pageType === "inSearchEva";

  const isAlgoliaPLPPage = props.pageType === "inPLPAlgolia";

  const isEvaPLPPage = props.pageType === "inPLPEva";

  return (
    <div className={classNames(styles.container, styles.single)}>
      {isAlgoliaSearchPage && (
        <SearchFilterDialog
          disableFilters={CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_FILTERS_ALGOLIA_SEARCH)}
        />
      )}
      {isAlgoliaPLPPage && (
        <SearchFilterDialog
          disableFilters={CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_FILTERS_ALGOLIA_PRODUCT_LISTING)}
        />
      )}
      {(isEvaSearchPage || isEvaPLPPage) && (
        <>
          <button type="button" className={styles.cta} onClick={() => setSorting(true)}>
            <Icon icon={IconSort} width={16} height={16} aria-hidden />
            {t("generic.sort_by")}
          </button>
          {isEvaSearchPage && <SearchSortDialog isOpen={isSorting} setOpen={setSorting} />}
          {isEvaPLPPage && <CategorySortDialog isOpen={isSorting} setOpen={setSorting} />}
        </>
      )}
    </div>
  );
}
